import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class FixedScrollService {

    readonly otherElementsSubject = new BehaviorSubject<HTMLElement[]>(null)
}